import medikreditclaimcsvService from '../services/medikreditclaimcsv.service';

const medikreditclaimcsvs = {
    namespaced: true,
    state: {},
    actions: {
        //READ
        get(_, params) {
            return medikreditclaimcsvService.get(params.id, params.urlParameters, params.requestId);
        },
        //UPDATE
        update(_, model) {
            return medikreditclaimcsvService.update(model);
        },

        //DELETE
        delete(_, id) {
            return medikreditclaimcsvService.delete(id);
        },
    },
    getters: {},
    mutations: {},
};

export default medikreditclaimcsvs;
